{
    "AutocalcdurationLabel": "Calculer automatiquement la durée lors de la programmation d'un rapport :",
    "BundleallemailattachinzipLabel": "Regroupez toutes les pièces jointes d'un courriel dans un fichier Zip :",
    "RunandcollatewithsimilarschedLabel": "Exécuter et collationner avec des calendriers de rapports périodiques similaires :",
    "Advanced_SectionHeader": "Avancé",
    "NAME": "Advanced"
}